import loadable from '@loadable/component';
import { Loader } from '@/components';

export const AsyncNewOfferDecreased = loadable(
  () => import('./NewOfferDecreased'),
  {
    fallback: <Loader />,
  },
);
